import { parseFullName } from 'parse-full-name';

interface IValidator {
	validate: <T>(subject: T) => Promise<any>;
}

export default class ValidationService {
	static either = (...validators: Array<IValidator>): IValidator => {
		return {
			validate: async <T>(subject: T): Promise<T> => {
				const errors = await Promise.all(
					validators.map((validator) => {
						return validator
							.validate(subject)
							.then(() => {
								return null;
							})
							.catch((err) => {
								return err;
							});
					}),
				);

				const receivedErrors = errors.filter((error) => error != null);
				if (receivedErrors.length > 0 && receivedErrors.length === validators.length) {
					throw receivedErrors[0];
				}

				return subject;
			},
		};
	};
}

export const ValidationFunctions = {
	fullName: (value: any): boolean => {
		const fullName = parseFullName(value);
		const validSegments = [fullName.first, fullName.last].filter(
			(segment) => segment != null && segment !== '',
		);

		// Needs to contain at least two segments
		return validSegments.length === 2;
	},
};
